<template>
  <NavBar/>
  <!-- <Transition name="fade" mode="out-in"> -->
    <!-- <HeaderTitle :componentName="currentComponent"/> -->
  <!-- </Transition> -->
  <router-view v-slot="{ Component }" :loader="loaderGif">
    <Transition name="fade" mode="out-in">
      <component :is="Component" @hook:mounted="storeCurrentComponent(Component)"/>
    </Transition>
  </router-view>
  <WebsiteFooter/>
</template>

<script>
// import HeaderTitle from './components/HeaderTitle.vue';
import NavBar from './components/NavBar.vue'
import WebsiteFooter from './components/WebsiteFooter.vue';

import LoaderGif from '@/assets/loader.gif';

export default {
  name: 'App',
  components: {
    NavBar,
    WebsiteFooter,
    // HeaderTitle
  },
  data() {
    return {
      currentComponent: "",
      loaderGif: ""
    }
  },
  watch: {
    $route(component) {
      this.currentComponent = component.name;
    }
  },
  mounted() {
    const img = new Image();
    img.src = LoaderGif;
    img.onload = () => {
      this.loaderGif = img.src;
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  /* font-family: Lexend Deca,sans-serif; */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter-from, .fade-leave-to {
  opacity: 0;
}
</style>
